import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

// Ek hi axios instance sab jagah use hoga
const api = axios.create({
    baseURL: API_BASE_URL
});

// Refresh kis role ka karna hai
const getRefreshUrl = () => {
    const role = localStorage.getItem('role');
    return role === 'POOJARI'
        ? '/api/poojaris/refresh'
        : '/api/users/refresh';
};

// Sab kuch saaf karke login pe bhejo
const forceLogout = () => {
    // ⚠️ role PEHLE padho, HATANE SE PEHLE.
    //
    // Purana code pehle removeItem('role') karta tha aur uske
    // baad getItem('role') - jo hamesha null aata tha. Isliye
    // poojari ko bhi hamesha user wale /login pe bheja jaata.
    const role = localStorage.getItem('role');

    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('role');

    window.location.href = role === 'POOJARI'
        ? '/poojari-login'
        : '/login';
};

// ===== REQUEST : har call mein token laga do =====
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ===== RESPONSE : 401 aaya toh refresh karo =====

// Ek saath 5 calls fail hui toh 5 baar refresh na ho
let isRefreshing = false;
let queue = [];

const processQueue = (error, token = null) => {
    queue.forEach(p => {
        if (error) p.reject(error);
        else p.resolve(token);
    });
    queue = [];
};

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const original = error.config;

        // 401 nahi hai, ya pehle bhi retry ho chuka
        if (error.response?.status !== 401
                || original._retry) {
            return Promise.reject(error);
        }

        // Refresh call khud fail hui - ab logout
        if (original.url?.includes('/refresh')) {
            forceLogout();
            return Promise.reject(error);
        }

        const refreshToken =
            localStorage.getItem('refreshToken');

        if (!refreshToken) {
            forceLogout();
            return Promise.reject(error);
        }

        // Koi aur pehle se refresh kar raha hai - wait karo
        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                queue.push({ resolve, reject });
            }).then(token => {
                original.headers.Authorization =
                    `Bearer ${token}`;
                return api(original);
            });
        }

        original._retry = true;
        isRefreshing = true;

        try {
            const { data } = await axios.post(
                `${API_BASE_URL}${getRefreshUrl()}`,
                { refreshToken });

            localStorage.setItem('token', data.token);
            localStorage.setItem('refreshToken',
                data.refreshToken);

            processQueue(null, data.token);

            original.headers.Authorization =
                `Bearer ${data.token}`;
            return api(original);

        } catch (err) {
            processQueue(err, null);
            forceLogout();
            return Promise.reject(err);
        } finally {
            isRefreshing = false;
        }
    }
);

export default api;